import { render, staticRenderFns } from "./hospitalStatisticsChild2023.vue?vue&type=template&id=0c48f9fe&scoped=true&"
import script from "./hospitalStatisticsChild2023.vue?vue&type=script&lang=js&"
export * from "./hospitalStatisticsChild2023.vue?vue&type=script&lang=js&"
import style0 from "./hospitalStatisticsChild2023.vue?vue&type=style&index=0&id=0c48f9fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c48f9fe",
  null
  
)

export default component.exports